// eslint-disable-next-line no-unused-vars
import { faTimes } from "@fortawesome/free-solid-svg-icons"; // Import the icon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; // Import the FontAwesomeIcon component
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import icon from "../../assets/SVG/circle-check.png";
import { useAuth } from "../../context/AuthContext";
import { useSubscription } from "../../context/SubscriptionContext";
import { getAllSubscriptions } from "../../services/subcriptionFn";
import AppLoader from "../loader/loader";
import Swal from "sweetalert2";
import { userCheckEligibility } from "../../services/cardsFn";

function Subscriptionplan() {
  const navigate = useNavigate();
  const [subcriptions, setSubcriptions] = useState(null);
  const [loading, setLoading] = useState();
  const { user, logout, userId } = useAuth();
  const { clearPackage } = useSubscription();
  const [isEligible, setIsEligible] = useState(false);
  console.log(userId, "userId");
  const { selectPackage } = useSubscription();

  const showAlert = (title, text, icon) => {
    Swal.fire({
      title,
      text,
      icon,
      confirmButtonText: "OK",
    });
  };

  useEffect(() => {
    handleCheckEligibility();
  }, []);

  const handleCheckEligibility = async () => {
    if (!userId || !userId._id) {
      console.error("userId is missing or doesn't have _id property:", userId);
      return;
    }
    
    const payload = {
      userId: userId._id,
      platform: "Stripe",
    };
    try {
      const response = await userCheckEligibility(payload);
      if (response.status === 200 || response.status === 201) {
        const { anotherPlatform } = response.data.data;
        setIsEligible(anotherPlatform);
      }
    } catch (error) {
      console.error("Error checking eligibility:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!userId || !userId?._id || !userId?.email) {
      console.log("User is not logged in or missing user ID/email");
      navigate("/signin");
      return;
    }
    fetchSubcriptions();
  }, [userId, navigate]);

  const fetchSubcriptions = async () => {
    try {
      setLoading(true);
      const response = await getAllSubscriptions();
      if (response.data.status === "success") {
        setSubcriptions(response.data.data);
      } else {
        showAlert(
          "Error",
          response?.data.message || "Registration failed.",
          "error"
        );
      }
    } catch (error) {
      showAlert("Error", "Error fetching subscriptions:", error);
    } finally {
      setLoading(false);
    }
  };

  // if (user && user?.isSubscribe === "Active") {
  //   navigate("/login-inner", { replace: true });
  // }

  const handlenavigateBack = () => {
    navigate(-1);
  };

  return (
    <>
      <AppLoader isVisible={loading} />
      <section className="sub-plan-section">
        <div className="sub-hero">
          <div className="container-sub-plan">
            <div className="box box-div">
              <div className="container">
                <div className="row d-flex justify-content-space-around align-items-center">
                  <div className="col-md-6 sub-plan-heading-col">
                    <div className="sub-plan-heading">
                      <p>subscription plans</p>
                    </div>
                  </div>
                  <div className="col-md-6 mb-4 icon-times-col">
                    <div className="icon-times">
                      <button className="close" onClick={handlenavigateBack}>
                        <FontAwesomeIcon
                          icon={faTimes}
                          className="sub-icon-times"
                        />
                      </button>
                    </div>
                  </div>

                  <div className="subcriptions-box">
                    {subcriptions?.map((pkg, index) => (
                      <div className="box-under" key={index}>
                        <div className="heading-sub">
                          <h6 className="package-name">{pkg?.name}</h6>
                          <p className="price">
                            {pkg?.price} <sub>/mo</sub>
                          </p>
                        </div>
                        <p className="point">
                          <img src={icon} alt="icon" />7 days free trial
                        </p>
                        <p className="point">
                          <img src={icon} alt="icon" />
                          {pkg?.limit} generation per month
                        </p>
                        <button
                          className="btn-1"
                          onClick={() => {
                            selectPackage({
                              _id: pkg._id,
                              name: pkg.name,
                              price: pkg.price,
                              limit: pkg.limit,
                            });
                            navigate("/payment");
                          }}
                        >
                          proceed
                        </button>
                      </div>
                    ))}
                  </div>

                  {/* <div className="col-md-6">
                  <div className="box-under">
                    <div className="heading-sub">
                      <h6 className="package-name">premium</h6>
                      <p className="price">
                        $1.99 <sub>/mo</sub>
                      </p>
                    </div>
                    <p className="point">
                      <img src={icon} alt="" className="" />7 days free trail
                    </p>
                    <p className="point">
                      <img src={icon} alt="" className="" />
                      45 generation per month
                    </p>
                    <button
                      className="btn-1"
                      onClick={() => navigate("/payment")}
                    >
                      proceed
                    </button>
                  </div>
                </div> */}
                  {/* 
                <div className="box-under1">
                  <div className="heading-sub">
                    <h6 className="package-name">gold</h6>
                    <p className="price">
                      $--.-- <sub>/mo</sub>
                    </p>
                  </div>
                  <p className="point">
                    <img src={icon} alt="" className="" />
                    00 days free trial
                  </p>
                  <p className="point">
                    <img src={icon} alt="" className="" />
                    00 generation per month
                  </p>
                  <p className="point">
                    <img src={icon} alt="" className="" />
                    00 audio generations
                  </p>
                  <button className="btn-2">comming soon</button>
                </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Subscriptionplan;
